import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <Section background="cream" className="py-20" data-id="element-82">
      <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-83">
        {/* For You */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-amber-500" data-id="element-84">
          <h3 className="text-2xl font-serif text-navy-900 mb-6" data-id="element-85">
            Es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-86">
            {['Estás cansada pero tu mente no se apaga.', 'Te despiertas a mitad de noche y tu cabeza se activa.', 'Sientes que el insomnio está afectando tu humor, tu paciencia y tu día.'].map((item, idx) => <li key={idx} className="flex items-start" data-id="element-87">
                <Check className="w-5 h-5 text-green-600 mr-3 mt-1 flex-shrink-0" data-id="element-88" />
                <span className="text-slate-700" data-id="element-89">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200" data-id="element-90">
          <h3 className="text-2xl font-serif text-slate-700 mb-6" data-id="element-91">
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-92">
            <li className="flex items-start" data-id="element-93">
              <X className="w-5 h-5 text-slate-400 mr-3 mt-1 flex-shrink-0" data-id="element-94" />
              <span className="text-slate-600" data-id="element-95">
                Sospechas apnea del sueño no tratada, crisis severas, o
                necesitas atención médica urgente.
              </span>
            </li>
          </ul>
          <p className="mt-6 text-sm text-slate-500 italic" data-id="element-96">
            *Este ebook es una guía educativa de bienestar, no un tratamiento
            médico.
          </p>
        </div>
      </div>
    </Section>;
}